module.exports = __webpack_public_path__ + "img/1496753736.694f0e6e.jpg";